import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref, computed, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
	imageSrc: {
		type: String,
		required: true
	}
},
  setup(__props) {

const props = __props



let mouseDownTime = 0;
const zoomLevel = ref(1);
const container = ref<HTMLElement | null>(null);
const image = ref<HTMLImageElement | null>(null);
const isDragging = ref(false);
const isMouseDown = ref(false);
const startX = ref(0);
const startY = ref(0);
const translateX = ref(0);
const translateY = ref(0);
const maxTranslateX = ref(0);
const maxTranslateY = ref(0);

// Computed styles for the image
const imageStyles = computed(() => ({
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	cursor: zoomLevel.value > 1 ? 'grab' : 'pointer',
	transform: `scale(${zoomLevel.value}) translate(${translateX.value}px, ${translateY.value}px)`,
	transition: isDragging.value ? 'none' : 'transform 0.3s ease'
}));

const handleZoomClick = (e: MouseEvent) => {
	if ((new Date().getTime() - mouseDownTime) > 200) {
		return;
	}
	if (zoomLevel.value === 1) {
		zoomLevel.value = 1.5;
	} else if (zoomLevel.value === 1.5) {
		zoomLevel.value = 2;
	} else {
		zoomLevel.value = 1;
		translateX.value = 0;
		translateY.value = 0;
	}
};

const startDrag = (e: MouseEvent) => {
	mouseDownTime = new Date().getTime();
	if (zoomLevel.value > 1) {
		isDragging.value = true;
		isMouseDown.value = true;
		startX.value = e.clientX;
		startY.value = e.clientY;
	}
};

const stopDrag = () => {
	isDragging.value = false;
	isMouseDown.value = false;
};

const onDrag = (e: MouseEvent) => {
	if (isDragging.value && zoomLevel.value > 1) {
		const containerWidth = container.value?.clientWidth ?? 0;
		const containerHeight = container.value?.clientHeight ?? 0;
		const imageWidth = containerWidth * zoomLevel.value;
		const imageHeight = containerHeight * zoomLevel.value;

		const dx = e.clientX - startX.value;
		const dy = e.clientY - startY.value;

		const newTranslateX = translateX.value + dx / zoomLevel.value;
		const newTranslateY = translateY.value + dy / zoomLevel.value;

		startX.value = e.clientX;
		startY.value = e.clientY;

		maxTranslateX.value = Math.max(0, (imageWidth - containerWidth) / (2 * zoomLevel.value));
		maxTranslateY.value = Math.max(0, (imageHeight - containerHeight) / (2 * zoomLevel.value));

		translateX.value = Math.min(maxTranslateX.value, Math.max(-maxTranslateX.value, newTranslateX));
		translateY.value = Math.min(maxTranslateY.value, Math.max(-maxTranslateY.value, newTranslateY));
	}
};

const onTouchStart = (e: TouchEvent) => {
	if (e.touches.length === 1) {
		const touchPoint = e.touches[0];
		mouseDownTime = new Date().getTime();
		if (zoomLevel.value > 1) {
			isDragging.value = true;
			isMouseDown.value = true;
			startX.value = touchPoint.clientX;
			startY.value = touchPoint.clientY;
		}
	}
};

const onTouchMove = (e: TouchEvent) => {
	if (e.touches.length === 1) {
		const touchPoint = e.touches[0];
		if (isDragging.value && zoomLevel.value > 1) {
			const containerWidth = container.value?.clientWidth ?? 0;
			const containerHeight = container.value?.clientHeight ?? 0;
			const imageWidth = containerWidth * zoomLevel.value;
			const imageHeight = containerHeight * zoomLevel.value;

			const dx = touchPoint.clientX - startX.value;
			const dy = touchPoint.clientY - startY.value;

			const newTranslateX = translateX.value + dx / zoomLevel.value;
			const newTranslateY = translateY.value + dy / zoomLevel.value;

			startX.value = touchPoint.clientX;
			startY.value = touchPoint.clientY;

			maxTranslateX.value = Math.max(0, (imageWidth - containerWidth) / (2 * zoomLevel.value));
			maxTranslateY.value = Math.max(0, (imageHeight - containerHeight) / (2 * zoomLevel.value));

			translateX.value = Math.min(maxTranslateX.value, Math.max(-maxTranslateX.value, newTranslateX));
			translateY.value = Math.min(maxTranslateY.value, Math.max(-maxTranslateY.value, newTranslateY));
		}
	}
};

const onTouchEnd = () => {
	stopDrag();
};

watch(zoomLevel, (newZoom) => {
	if (newZoom === 1) {
		translateX.value = 0;
		translateY.value = 0;
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "zoom-viewer-container",
    ref_key: "container",
    ref: container,
    onMousedown: startDrag,
    onMouseup: stopDrag,
    onMouseleave: stopDrag,
    onMousemove: onDrag,
    onTouchstart: onTouchStart,
    onTouchmove: onTouchMove,
    onTouchend: onTouchEnd
  }, [
    _createElementVNode("img", {
      ref_key: "image",
      ref: image,
      src: __props.imageSrc,
      style: _normalizeStyle(_unref(imageStyles)),
      alt: "Zoomable Image",
      onClick: handleZoomClick,
      onDragstart: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
    }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */, _hoisted_1)
  ], 544 /* HYDRATE_EVENTS, NEED_PATCH */))
}
}

})